module.exports = __webpack_public_path__ + "static/media/logoEACHBranco.ef94d3ca.svg";